import { CpmButton } from '../../../components/design-system';
import { REPORTS_COPY } from '../copy';

interface FilteredEmptyProps {
    title?: string;
    restated?: string;
    cause?: string;
    totalInPlace?: string;
    onClear: () => void;
}

export default function FilteredEmpty({
    title = REPORTS_COPY.FILTERED_EMPTY,
    restated,
    cause = 'The search and filters caused this, not an empty menu.',
    totalInPlace,
    onClear,
}: FilteredEmptyProps) {
    return (
        <div
            className="flex items-start"
            style={{
                gap: 14,
                padding: 22,
                border: '1.5px solid var(--cpm-info-border)',
                borderRadius: 10,
                background: 'var(--cpm-info-bg)',
            }}
        >
            <span
                className="inline-flex items-center justify-center shrink-0"
                style={{
                    width: 38,
                    height: 38,
                    borderRadius: 10,
                    background: '#fff',
                    border: '1px solid var(--cpm-border-strong)',
                    color: 'var(--cpm-info-text)',
                }}
            >
                <svg
                    width="17"
                    height="17"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                >
                    <path d="M4 5h16l-6 8v5l-4 2v-7L4 5z" />
                </svg>
            </span>
            <div className="min-w-0 flex-1">
                <div
                    style={{
                        fontSize: 14.5,
                        fontWeight: 800,
                        letterSpacing: '-0.01em',
                        color: 'var(--cpm-info-text)',
                    }}
                >
                    {title}
                </div>
                <div
                    style={{
                        marginTop: 4,
                        fontSize: 12.5,
                        fontWeight: 500,
                        lineHeight: 1.5,
                        color: 'var(--cpm-text-secondary)',
                    }}
                >
                    {cause}
                    {restated ? ` ${restated}` : ''}
                </div>
                <div className="flex items-center flex-wrap" style={{ gap: 9, marginTop: 14 }}>
                    <CpmButton variant="outline" size="sm" onClick={onClear}>
                        {REPORTS_COPY.CLEAR_SEARCH_FILTERS}
                    </CpmButton>
                    {totalInPlace ? (
                        <span
                            style={{
                                fontSize: 11.5,
                                fontWeight: 700,
                                color: 'var(--cpm-text-tertiary)',
                                fontVariantNumeric: 'tabular-nums',
                            }}
                        >
                            {totalInPlace}
                        </span>
                    ) : null}
                </div>
            </div>
        </div>
    );
}
